import {Doc} from '../../modules'

export const DocPage = () => {
  return <Doc />
}
